import './style.scss'
import Icon from './arrow.svg'


const Arrow = () => {
    return(
        <>
        <img src={Icon}/>
        </>
    )
}

export default Arrow;